import { Poppins } from 'next/font/google';
import { createTheme } from '@mui/material/styles';

// Fonts needs to be changed here
const poppins = Poppins({
  weight: ['300', '400', '500', '600', '700'],
  subsets: ['latin'],
  display: 'swap',
});

const theme = createTheme({
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          WebkitTapHighlightColor: 'transparent',
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
        },
        body: {
          backgroundColor: '#f4f4f8',
        },
      },
    },
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#EF8549',
      light: '#FFD9C3',
      dark: '#ED7C69',
      contrastText: '#C0C0CA',
    },
    secondary: {
      main: '#F4F4F8',
      light: '#ffffff',
    },
    grey: {
      100: '#F5F5F5',
      200: '#F4F4F8',
      300: '#ECECF5',
      400: '#E9E9F4',
      500: '#888D95',
      600: '#53575D',
      700: '#242528',
      800: '#323232CC',
      900: '#59595a',
    },
    warning: {
      main: '#D5381D',
    },
    success: {
      main: '#66DCA7',
    },
    error: {
      main: '#D5381D',
    },
  },

  typography: {
    fontFamily: poppins.style.fontFamily,
    h1: {
      fontSize: 28,
      color: '#000000',
      fontWeight: 600,
    },
    h2: {
      fontSize: 26,
      color: '#000000',
      fontWeight: 600,
    },
    h3: {
      fontSize: 24,
      color: '#000000',

      fontWeight: 400,
    },
    h4: {
      fontSize: 22,
      color: '#000000',

      fontWeight: 500,
    },
    h5: {
      fontSize: 20,
      color: '#000000',

      fontWeight: 500,
    },
    h6: {
      fontSize: 18,
      color: '#000000',

      fontWeight: 500,
    },
    subtitle1: {
      fontSize: 16,
      color: '#000000',
      fontWeight: 400,
    },
    subtitle2: {
      fontSize: 14,
      color: '#000000',

      fontWeight: 400,
    },
    body1: {
      fontSize: 12,
      color: '#000000',
    },
    caption: {
      fontSize: 12,
      color: '#888D95',
      fontWeight: 400,
    },
  },
});

export default theme;
